import { render, staticRenderFns } from "./CadastroAgendaCompartilhada.vue?vue&type=template&id=7e84d7b7&"
import script from "./CadastroAgendaCompartilhada.vue?vue&type=script&lang=js&"
export * from "./CadastroAgendaCompartilhada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports